import axios from "axios";
import { store } from "../redux/store";
import NotifierActions from "../redux/notifier/actions";
import { REFRESH_TOKEN } from "./service.js";
import subMinutes from 'date-fns/subMinutes';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import {
  armoniaTokenName,
  getToken,
  sessionGetData, sessionRemoveAllData,
  sessionRemoveData,
  sessionSaveData
} from "./session-storage-management/session-storage-management";
import Cookies from "js-cookie";







/**

 *  Questa funzione è un interceptors - si  occupa di intercettare ogni chiamata e gestire i messaggi di errore nel componente NOTIFIER

 */

axios.interceptors.response.use(
  response => {
    // se la chiamata è una POST etc.. ed è andata in SUCCESS faccio visualizzare il  messaggio

    if (response.data.info && response.data.info[0].msg && response.config.method !== 'get')
      store.dispatch(NotifierActions.SHOW_NOTIFICATION({ message: response.data.info[0].msg, variant: 'success', open: true }));
    return response;
  },

  err => {

    const error = err.response;
    let _message = "";
    let _icon = "error";



    if (error.data.message) {
      _message = error.data.message;

    } else if (error.data.warnings) {
      _message = error.data.warnings[0].msg;

    } else if (error.data.errors && error.data.errors[0] && error.data.errors[0].msg) {
      _message = error.data.errors[0].msg;

    } else if (error.data.info && error.data.info[0] && error.data.info[0].msg) {
      _message = error.data.info[0].msg;
      _icon = "warning";
    }

    if (error.status === 503) {
      _message = "Servizio non raggiungibile";
    }



    if (error.status === 401) {
      // sessionStorage.removeItem('auth');
      // TODO Da togliere quando il BE sarà pronto
      Cookies.remove(armoniaTokenName);
      sessionRemoveAllData();
      // sessionRemoveData('filters');



      if (!window.location.href.includes('login')) {
        window.location.href = '/login';

      } else {
        _message = "Autenticazione fallita, contattare l'help desk.";

      }

    }



    //se ho abilitato la debugMode tramite localStorage o sono in locale

    if (window.location.href.includes('localhost') || sessionGetData('debugMode')) {

      console.groupCollapsed("ERRORE HTTP REQUEST");
      console.log("Message %c" + _message, 'color:red; font-weight:bold;');
      console.log("%cError ", 'color:violet; font-weight:bold;', error);
      console.groupEnd();

    }



    if (_message) {
      if (store.getState() && store.getState().notification && store.getState().notification.open === true) {
        store.dispatch(NotifierActions.SHOW_NOTIFICATION({ message: _message, variant: _icon, open: false }));
      }

      store.dispatch(NotifierActions.SHOW_NOTIFICATION({ message: _message, variant: _icon, open: true }));
    }

    return Promise.reject(error);

  }

);



/**

 * 

 *  Questa è una funzione per gestire le chiamate all'interno dell'applicativo,

 *  nell'if case prende il token dal sessionStorage e lo inserisce all'interno dell'header della chiamata

 *  dopo di che tramite lo switch viene gestito il parametro type che genererà un httpRequest in base al parametro immesso

 * 

 * @param {*} type : GET , PUT , POST , DELETE , EXPORT

 * @param {*} url  :  Url della chiamata

 * @param {*} params : parametri da passare in QueryString

 * @param {*} body : Eventuale body per post o put

 */

/**const httpRefreshManager = (() => {
  let isRefreshing = false;

  const hasToRefresh = (token) => {

    if (token !== null) {

      const refreshIntervalMinute = parseInt(JSON.parse(atob(token.split(".")[1]))["intervalRefreshMinutes"].toFixed(0));
      const currenDate = new Date();
      const tokenExpTimestamp = parseInt(JSON.parse(atob(token.split(".")[1]))["exp"].toFixed(0));
      const tokenExpDate = new Date(tokenExpTimestamp * 1000);
      const startRefresh = subMinutes(tokenExpDate, refreshIntervalMinute);


      return (isAfter(currenDate, startRefresh) && isBefore(currenDate, tokenExpDate))

    }
    // funzione per capire se e' da refreshare oppure no
    return false;
  }

  const callRefresh = (token) => {
    // chiamata di refresh del token
    // axios. .....
    return REFRESH_TOKEN(token)
  }

  const checkAndRefresh = async (token) => {
    if (!isRefreshing && hasToRefresh(token)) {
      isRefreshing = true
      try {
        const resultRefresh = await callRefresh(token)
        // let newAuthToken = { token: resultRefresh.data.token }
        // sessionSaveData(JSON.stringify(newAuthToken), 'auth');
        // sessionStorage.setItem('auth', JSON.stringify(newAuthToken));
      } catch(e){
        console.log('errore durante il refresh', e)
      }finally {
        isRefreshing = false
      }

    }
  }

  return {
    checkAndRefresh
  }

})(); */


export function defaultHTTPRequests(type, url, params, body, prom) {
  
  switch (type) {

    case "POST":
      return axios.post(url, body);

    case "PUT":
      return axios.put(url, body);

    case "GET":
      return axios.get(url, { params: params });

    case "DELETE":
      return axios({
        url: url,
        method: 'DELETE',
        data: body
      });

    case "EXPORT":
      return axios({
        url: url,
        params: { ...params },
        method: 'GET',
        responseType: 'blob'
      });

    case "IMPORT_EXPORT":
      return axios({
        url: url,
        params: { ...params },
        data: body,
        method: 'POST',
        responseType: 'blob'
      });

    default:
      break;

  }

}
